/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {existsUnprocessedEvents} from '../api'

export const useMutationExistsUnprocessedEvents = createReactQueryMutationHook('existsUnprocessedEvents', existsUnprocessedEvents)
